import Image from 'next/image';
import React, { FC, HtmlHTMLAttributes } from 'react';
import { FaArrowDown, FaArrowLeft, FaArrowRight, FaArrowUp } from 'react-icons/fa';
import styled from 'styled-components';
import ImageButton from 'public/bxs_image-add.svg';
import { media } from 'utils/media';

export const InsertImageButton: FC<
  { label: string; onClick?: () => void; arrowPosition?: 'left' | 'right' | 'up' | 'down' | 'none' } & HtmlHTMLAttributes<HTMLButtonElement>
> = ({ label, arrowPosition, onClick, ...args }) => {
  const arrowComponents = {
    down: <FaArrowDown />,
    up: <FaArrowUp />,
    left: <FaArrowLeft />,
    right: <FaArrowRight />,
    none: <></>,
  };

  return (
    <Container {...args} onClick={() => onClick?.()}>
      <div>
        <Image layout="responsive" src={ImageButton} alt="add-image" height={24} width={24} />
      </div>
      <div>
        <Label>{label}</Label>
      </div>
      <div>{arrowPosition && arrowComponents[arrowPosition]}</div>
    </Container>
  );
};

export const Container = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 25px;
  background-color: #174f68;
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  outline: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  & > div:first-child {
    width: 35px;
    height: 35px;
    margin-right: 1rem;
  }

  & > div:last-child {
    margin-left: 1rem;
  }

  @media (max-width: 768px) {
    & > div:first-child {
      width: 18px;
      height: 18px;
    }
  }
`;

export const Label = styled.strong<{ color?: string }>`
  font-family: 'Nunito';
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  color: ${({ color }) => color};
  white-space: pre-wrap;

  @media (max-width: 768px) {
    font-size: 14px;
  }
  ${media('<=tablet')} {
    display: none !important;
  }
`;
